var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from "../Button";
import Heading from "../Heading";
import Markdown from "../Markdown";
import { Col, Grid } from "../grid";
import React from 'react';
import { layout } from 'styled-system';
import { css, mq, styled } from "../../utils";
var StyledBanner = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    display: flex;\n    flex-direction: column;\n\n    ", ";\n  "], ["\n    background-color: ", ";\n    display: flex;\n    flex-direction: column;\n\n    ",
        ";\n  "])), colors.gray4, mq({
        padding: ['1rem 1rem 0', '2rem 2rem 0', '3rem 3rem 0', '4rem 4rem 0'],
    }));
}, layout);
var StyledGrid = styled(Grid)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n\n  ", "\n"], ["\n  position: relative;\n\n  ",
    "\n"])), mq({
    paddingBottom: ['2rem', '2rem', '4rem'],
}));
var StyledMarkdown = styled(Markdown)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  p {\n    margin: 1rem 0;\n  }\n"], ["\n  p {\n    margin: 1rem 0;\n  }\n"])));
var CustomerCareImage = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  height: 400px;\n  right: 0;\n  bottom: 0;\n  width: 60%;\n\n  ", "\n"], ["\n  position: absolute;\n  height: 400px;\n  right: 0;\n  bottom: 0;\n  width: 60%;\n\n  ",
    "\n"])), mq({
    display: ['none', 'none', 'block'],
}));
var TeamImage = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  right: 4rem;\n  bottom: 0;\n  height: auto;\n  width: 100%;\n  z-index: 1;\n"], ["\n  position: absolute;\n  right: 4rem;\n  bottom: 0;\n  height: auto;\n  width: 100%;\n  z-index: 1;\n"])));
var BackgroundImage = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n\n  ", "\n"], ["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n\n  ",
    "\n"])), mq({
    width: ['160%', '160%', '160%', '140%'],
}));
var WideBanner = function (_a) {
    var title = _a.title, content = _a.content, onClick = _a.onClick, buttonLabel = _a.buttonLabel, backgroundImage = _a.backgroundImage, teamImage = _a.teamImage, className = _a.className, _b = _a.buttonDisabled, buttonDisabled = _b === void 0 ? false : _b, layoutProps = __rest(_a, ["title", "content", "onClick", "buttonLabel", "backgroundImage", "teamImage", "className", "buttonDisabled"]);
    return (React.createElement(StyledBanner, __assign({ "data-component": "WideBanner", className: className }, layoutProps),
        React.createElement(StyledGrid, null,
            React.createElement(Col, { width: [1, 1, 1, 2 / 3] },
                React.createElement(Heading.Heading2, null, title),
                React.createElement(StyledMarkdown, { source: content }),
                React.createElement(Button, { outline: true, disabled: buttonDisabled, onClick: onClick }, buttonLabel)),
            backgroundImage && teamImage && (React.createElement(CustomerCareImage, null,
                React.createElement(BackgroundImage, { src: backgroundImage, alt: "customer_care_background" }),
                React.createElement(TeamImage, { src: teamImage, alt: "customer_care_team" }))))));
};
export default WideBanner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=WideBanner.js.map